module.exports = __webpack_public_path__ + "img/the-netherlands-colorectal-cancer-female.d7b3b5e6.png";